// Which Tavern pings (replies to you, mentions of you) you have already
// laid eyes on. A fresh ping gets a tint the first time it scrolls into
// view; once seen it is remembered here so the tint never comes back.
import { safeSetItem } from '../localStorageQuota';

const KEY = 'valkenhall.tavern.seenPings';
const CAP = 500;
let cache = null;

function load() {
  if (cache) return cache;
  try {
    const arr = JSON.parse(localStorage.getItem(KEY) || '[]');
    cache = new Set(Array.isArray(arr) ? arr : []);
  } catch {
    cache = new Set();
  }
  return cache;
}

export function isPingSeen(id) {
  return load().has(id);
}

export function markPingSeen(id) {
  const set = load();
  if (!id || set.has(id)) return;
  set.add(id);
  const arr = [...set].slice(-CAP);
  cache = new Set(arr);
  safeSetItem(KEY, JSON.stringify(arr));
}

export function _resetForTests() {
  cache = null;
  try { localStorage.removeItem(KEY); } catch {}
}
